export const InfoIcon = (props) => {
	const { className, size = 32, margin } = props;

	return (
		<img src="gif/info.gif" width={size} height={size} className={className} style={{ margin }} />
	);
};